import React from 'react';
import formattedAmount from '../../../resale/seller/components/utils';
import './total.css';

export default function Total({ quantity, total, totalData = {}}) {
    const { title, display_total, currency, title_aria_label } = totalData;

    return (
        <div className='neo-total-card'>
            <p className='neo-total-left'>
                <h3 className='neo-total-title' aria-label={`${title}, ${title_aria_label}: ${quantity}`}>{title}</h3>
            </p>
            {  display_total && (
                <div className='neo-total-right'>
                    <div className='neo-total-price'>{formattedAmount(total || 0, currency)}</div>
                </div>)
            }
        </div>
    )
}